module.exports = __webpack_public_path__ + "img/personnage_choix_3.06ebee6e.png";